import type {Table as ReactTable} from '@tanstack/react-table';

import {localeCompareSort} from '@/utils/localeCompareSort';

export const getColumnFilterOptions =
  (columnId: string) => (table: ReactTable<unknown>) =>
    [
      ...new Set(
        table
          .getPreFilteredRowModel()
          .flatRows.map(row => String(row.getValue(columnId) ?? ''))
          .filter(Boolean)
      ),
    ]
      .sort(localeCompareSort)
      .map(value => ({label: value, value}));
